<div class="page-content d-flex align-items-center justify-content-center">
  <div class="card col-11 col-md-6 col-lg-4 shadow rounded p-4 border-0">
    <div class="card-body p-0">
      <h5 class="card-title text-center mb-4">{{ title | transloco }}</h5>
      @if (!success) {
      <form [formGroup]="form">
        <div class="input-group mb-3">
          <span class="input-group-text"><i class="bi bi-lock"></i></span>
          <div class="form-floating">
            <input
              [type]="passwordChecked ? 'text' : 'password'"
              class="form-control"
              id="password"
              formControlName="password"
              placeholder="{{ 'create_password' | transloco }}"
              [class.is-invalid]="form.controls['password'].invalid && form.controls['password'].touched"
            />
            <label for="password" [appRequiredAsterisk]="'password'" [formGroup]="form">
              {{ 'create_password' | transloco }}
            </label>
          </div>
          <span class="input-group-text">
            <label class="btn btn-outline-secondary" for="togglePassword" (click)="passwordChecked = !passwordChecked">
              <i class="bi" id="eyeIcon" [class]="passwordChecked ? 'bi-eye' : 'bi-eye-slash'"></i>
            </label>
          </span>
          @if (form.controls['password'].touched && form.controls['password'].hasError('required')) {
          <div class="invalid-feedback">
            {{ 'error.fill_field' | transloco }}
          </div>
          } @else if (form.controls['password'].touched && form.controls['password'].hasError('passwordInvalid')) {
          <div class="invalid-feedback">
            {{ 'error.password' | transloco }}
          </div>
          }
        </div>

        <div class="input-group mb-3">
          <span class="input-group-text"><i class="bi bi-lock"></i></span>
          <div class="form-floating">
            <input
              [type]="passwordChecked ? 'text' : 'password'"
              class="form-control"
              id="repeat_password"
              formControlName="repeat_password"
              placeholder="{{ 'repeat_password' | transloco }}"
              [class.is-invalid]="form.controls['repeat_password'].invalid && form.controls['repeat_password'].touched"
            />
            <label for="repeat_password" [appRequiredAsterisk]="'repeat_password'" [formGroup]="form">
              {{ 'repeat_password' | transloco }}
            </label>
          </div>
          <span class="input-group-text">
            <label class="btn btn-outline-secondary" for="togglePassword" (click)="passwordChecked = !passwordChecked">
              <i class="bi" id="eyeIcon" [class]="passwordChecked ? 'bi-eye' : 'bi-eye-slash'"></i>
            </label>
          </span>
          @if (form.controls['repeat_password'].touched && form.controls['repeat_password'].hasError('required')) {
          <div class="invalid-feedback">
            {{ 'error.fill_field' | transloco }}
          </div>
          } @else if (form.hasError('passwordMismatch')) {
          <div class="invalid-feedback d-block">
            {{ 'error.password_repeat' | transloco }}
          </div>
          }
        </div>

        <button
          type="submit"
          class="btn btn-primary w-100"
          (click)="submit()"
          (keyup.enter)="submit()"
          [disabled]="!form.valid"
        >
          @if (!checkedSpiner) {
          <span>{{ 'save' | transloco }}</span>
          } @else {
          <div class="spinner-border spinner-border-sm"></div>
          }
        </button>
      </form>
      } @else {
      <div class="d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center">
        <i class="bi bi-check-lg text-primary display-4"></i>
        <div class="fw-bold text-primary fs-4">{{ 'success' | transloco }}!</div>
        <div class="d-flex justify-content-center gap-2 mt-3">
          <a [routerLink]="['/sign-in']" routerLinkActive="router-link-active" class="link-primary">{{
            'sign_in' | transloco
          }}</a>
        </div>
      </div>
      }
    </div>
  </div>
</div>
